import _ from "./_Stack.js";
import h from "./_baseIsEqual.js";
var p = 1, w = 2;
function L(n, O, e, i) {
  var f = e.length, v = f, A = !i;
  if (n == null)
    return !v;
  for (n = Object(n); f--; ) {
    var r = e[f];
    if (A && r[2] ? r[1] !== n[r[0]] : !(r[0] in n))
      return !1;
  }
  for (; ++f < v; ) {
    r = e[f];
    var l = r[0], u = n[l], E = r[1];
    if (A && r[2]) {
      if (u === void 0 && !(l in n))
        return !1;
    } else {
      var R = new _();
      if (i)
        var s = i(u, E, l, n, O, R);
      if (!(s === void 0 ? h(E, u, p | w, i, R) : s))
        return !1;
    }
  }
  return !0;
}
export {
  L as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseIsMatch.js
// module id = 1431
// module chunks = 41